let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9X2cH")).then(() => parcelRequire('1hBh4'));